(function() {

  angular
  .module('meanApp')
  .factory('User', User);

  User.$inject = [
    '$http', 
    'httpAuth', 
    '$window', 
    '$q', 
    '$rootScope', 
    'authentication', 
    'Model',
    'Allergen',
    'ingredientsManager'];
  function User (
    $http, 
    httpAuth, 
    $window, 
    $q, 
    $rootScope,
    authentication, 
    Model,
    Allergen,
    ingredientsManager) {
    var User = function (userData) {
    	Model.apply(this, arguments);
    },
    USER_COLORS = ['#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961' ,'#03C03C', '#FDFD96', '#779ECB', '#966FD6'];

    User.APIPath = 'users';
    User.prototype = {

        getAPIPath : function() {
            return User.APIPath;
        },

        getName : function () {
            var name = this.name || this.email.split('@')[0],
            firstChar = name.charAt(0);

        	return firstChar.toUpperCase() + name.slice(1);
        },

        /***Returns the role of the user **/
        getRole : function () {
            var role = this.role,
            ans = '';
            switch (role) {
                case 'admin' : ans = 'Administrateur'; break; //red
                case 'author' : ans = 'Auteur'; break; // yellow
                default : ans = 'Membre'; //blue
            }
            return ans;
        },

        getLabelClassRole : function() {
            var role = this.role,
            ans = '';
            switch (role) {
                case 'admin' : ans = 'label-danger'; break; //red
                case 'author' : ans = 'label-success'; break; // yellow
                default : ans = 'label-primary'; //blue
            }
            return ans;
        },

        hasProfilePicture : function () {
            return !(!this.avatarFilePath);
        },

        getThumb : function (size) {
            return 'api/thumb/users/'+this._id+'/size/'+size+'/update/'+this.avatarUpdate;
        },


        getColor : function() {
        	var initials = this.getInitials(),
        	nbColors = USER_COLORS.length,
        	toBeReturned = USER_COLORS[0],
        	firstLetter = parseInt(initials.charAt(0), 36) - 9;
        	if (initials.length === 2) {
        		var secondLetter = parseInt(initials.charAt(1), 36) - 9,
        		average = (firstLetter + secondLetter)/2,
        		ratio = average/26; //26 is the number of letters in occidental alphabet
				toBeReturned = USER_COLORS[Math.trunc(ratio*nbColors)];
        	}
        	else {
        		toBeReturned = USER_COLORS[Math.trunc((firstLetter/26)*nbColors)];
        	}
        	console.log(toBeReturned);
        	return toBeReturned;
        },

        getIMC : function() {
            var IMC = '';
            if (this.size && this.weight) {
                IMC = this.weight/(this.size/100*this.size/100);
                IMC = Math.trunc(IMC*10)/10;
            }
            return IMC;
        },

        //return the margin left to apply in percentage
        getIMCIndicatorPosition : function () {
            //alert('in imc position');
            return (100*this.getIMC()/55) + '%';
        },

        getCreationDate : function() {
            //TODO one day convert this in other languages
            return new Date(this.createdAt).toLocaleString('fr-FR');
        },

        getIMCStatus : function() {
            var IMCValue = this.getIMC(),
            IMCStatus = 'Anorexie/dénutrition';

            if (IMCValue > 40) {
                IMCStatus = 'Obésité morbide';
            }
            else if (IMCValue > 35){
                IMCStatus = 'Obésité élevée';
            }
            else if (IMCValue > 30){
                IMCStatus = 'Obésité modérée';
            }
            else if (IMCValue > 25){
                IMCStatus = 'Surpoids';
            }
            else if (IMCValue > 18.5){
                IMCStatus = 'Corpulence normale';
            }
            else if (IMCValue > 16.5){
                IMCStatus = 'Maigreur';
            }

            return IMCStatus;
        },

        isAdmin : function() {
            return this.role === 'admin';
        },

        getInitials : function() {
        	var initials = '';
        	if (this.name) {
        		initials = this.name.charAt(0);
        	}
        	else {
        		initials = this.email ? this.email.charAt(0) : '';
        	}
        	return initials.toUpperCase();
        },

        logout : function(callback) {
        	authentication.removeToken();
      		if (callback) {
        		callback();
      		}
        },
        
        resetPassword : function (userData) {
            console.log('resetPassword triggered');
            console.log('user data is ' + userData);
            return $http.post('/api/password', userData);
        },


        login : function() {
        	var deferred = $q.defer();
            var scope = this;
            $http.post('/api/login', scope)
				.success(function(result) {
					//merge data in Js with data from server, priority given to data from server
					angular.extend(scope, result.user);
					$rootScope.currentUser = scope;
                    console.log('token to save after login'+result.token);
					authentication.saveToken(result.token);
					$rootScope.isLoggedIn = true;
					deferred.resolve(result);
				})
				.error(function(err) {
				  deferred.reject(err);
				});
            return deferred.promise;
        },

        register : function() {
        	var deferred = $q.defer();
            var scope = this;
            $http.post('/api/register', scope)
				.success(function(result) {
					//merge data in Js with data from server, priority given to data from server
					angular.extend(scope, result.user);
					$rootScope.currentUser = scope;
					authentication.saveToken(result.token);
					$rootScope.isLoggedIn = true;
					deferred.resolve(result);
				})
				.error(function(err) {
				  deferred.reject(err);
				});
            return deferred.promise;
        },

        changePassword : function(formData) {
            var deferred = $q.defer(),
            scope = this;
            
            httpAuth.post('/api/changepassword/', formData, {
                headers: {'Content-Type': 'application/json' }
            })
            .success(function(result) {
                console.log('JS front end success for updating password user profile');
                deferred.resolve(result);
            }.bind(this))
            .error(function(err) {
                console.log('JS front end error for updating password user profile');
                deferred.reject(err);
            });
            return deferred.promise;
        },

        //the API is the following : /api/users/{id}/avatars/1
        uploadProfilePicture : function(formData) {
            var deferred = $q.defer(),
            scope = this;
            
            httpAuth.post('/api/users/'+ this._id + '/avatars/1', formData, {
                headers: {'Content-Type': undefined }
            })
            .success(function(result) {
                console.log('JS front end success for uploadProfilePicture');
                //merge data in Js with data from server, priority given to data from server
                /**angular.extend(scope, result.user);
                $rootScope.currentUser = scope;
                authentication.saveToken(result.token);
                $rootScope.isLoggedIn = true;**/
                this.avatarUpdate = result.avatarUpdate;
                console.log('avatar update '+ this.avatarUpdate);
                deferred.resolve(result);
            }.bind(this))
            .error(function(err) {
                console.log('JS front end success for uploadProfilePicture');
                deferred.reject(err);
            });
            return deferred.promise;
        },

        addAllergen: function(allergenId) {
            var deferred = $q.defer();
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.post('/api/users/'+this._id +'/'+ Allergen.APIPath + '/' + allergenId, {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function() {
                console.log('the api add allergen succeeded');
                deferred.resolve();
            })
            .error(function(err) {
                deferred.reject(err);
            });

            return deferred.promise;
        },

        deleteAllergen: function(allergenId) {
            var deferred = $q.defer();
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.delete('/api/users/'+this._id +'/'+ Allergen.APIPath + '/' + allergenId, {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function() {
                console.log('the api add allergen succeeded');
                deferred.resolve();
            })
            .error(function(err) {
                deferred.reject(err);
            });

            return deferred.promise;
        },

        getIngredientsLiked: function(page) {
            var deferred = $q.defer();
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.get('/api/users/'+this._id +'/ingredientsLike/page/' + page, {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(ingredients) {
                //put ingredient in the cache and transform them into models
                var ingredientsArray = [];
                ingredients.forEach(function(ingredient) {
                    ingredientsArray.push(ingredientsManager._retrieveInstance(ingredient.slug, ingredient));
                });
                console.log('the api add allergen succeeded');
                deferred.resolve(ingredientsArray);
            })
            .error(function(err) {
                deferred.reject(err);
            });

            return deferred.promise;
        },

        getIngredientsDisliked : function(page) {
            var deferred = $q.defer();
            //step 1 get the id of current user
            //step 2 perform the call
            httpAuth.get('/api/users/'+this._id +'/ingredientsDislike/page/' + page, {}, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .success(function(ingredients) {
                //put ingredient in the cache and transform them into models
                var ingredientsArray = [];
                ingredients.forEach(function(ingredient) {
                    ingredientsArray.push(ingredientsManager._retrieveInstance(ingredient.slug, ingredient));
                });
                console.log('the api add allergen succeeded');
                deferred.resolve(ingredientsArray);
            })
            .error(function(err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }




    };

    angular.extend(User.prototype, Model.prototype);

    return User;
  };



})();